function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import { useCallback, useState } from 'react';
var useSetState = function useSetState(initialState) {
    if (initialState === void 0) {
        initialState = {};
    }
    var _a = useState(initialState), state = _a[0], set = _a[1];
    var setState = useCallback(function(patch) {
        set(function(prevState) {
            return Object.assign({}, prevState, _instanceof(patch, Function) ? patch(prevState) : patch);
        });
    }, []);
    return [
        state,
        setState
    ];
};
export default useSetState;
